// Đường dẫn phải khớp với các import() trong lazy() ở AppRoutes.tsx — cập nhật thủ công khi thêm/bớt route.
export const preloadAllPages = () => {
  const preloaders: Array<() => Promise<any>> = [
    () => import('./pages/dashboard'),
    () => import('./pages/user'),
    () => import('./pages/user/user/UserDetails'),
    () => import('./pages/user/user-online'),
    () => import('./pages/user/user-address'),
    () => import('./pages/franchise/table'),
    () => import('./pages/franchise/tree'),
    () => import('./pages/franchise/level-setting-history'),
    () => import('./pages/franchise/commission'),
    () => import('./pages/user/user/UserDetail'),
    () => import('./pages/transaction/transaction/TransactionList'),
    () => import('./pages/transaction/withdraw/WithdrawProgress'),
    () => import('./pages/report/system'),
    () => import('./pages/config/maintenance/maintenanceConfig'),
    () => import('./pages/config/news'),
    () => import('./pages/config/news/createNews'),
    () => import('./pages/config/news/editNews'),
    () => import('./pages/profit-invest'),
    () => import('./pages/invest/history'),
    () => import('./pages/invest/investment-withdrawals'),
    () => import('./pages/rwa-entitlement'),
    () => import('./pages/commission/direct'),
    () => import('./pages/commission/sunline-samerank'),
    () => import('./pages/commission/rank-tracking'),
    () => import('./pages/commission/set-rank'),
    () => import('./pages/user/user-infomation'),
  ]
  preloaders.forEach((preload) => {
    preload().catch(() => {})
  })
}
